import admin_orgs from "../api/admin/admin_orgs"
import orgadmin_ords from "../api/orgadmin/orgadmin_orgs";
import {useEffect, useState} from "react";
import arrow from "../assets/arrow_back.png";
import roles from "../models/Roles";
import GenericDialog from "./GenericDialog";

const OrganisationAddNotificationMembers = (props) => {
    const hide = props.hide;
    const role_id = props.role;
    const org_id = props.org_id;
    const profile = props.profile;
    const [users, setUsers] = useState();

    const [showErrorDialog, setShowErrorDialog] = useState(false);
    const [error, setError] = useState();
    const [errorDescription, setErrorDescription] = useState();
    const okButton = [{"text":"OK", "id": "1"}];

    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [successTitle, setSuccessTitle] = useState("Success");
    const [successDescription, setSuccessDescription] = useState("Invite successfully sent.");


    const handleCancelClick = () => {
        hide();
    }

    const handleOKDialogResult = (res) => {
        setShowErrorDialog(false);
    }

    const handleSendClick = () => {
        if (!profile) return;
        for(let i=0;i<users.length;i++){
            if (users[i].email != "" && users[i].email != "{sent}"){
                let adjustedRole = role_id;
                if (profile.role_id === roles.ROLE_ADMIN)
                    adjustedRole = roles.ROLE_ADMIN;

                let body = {
                    "email": users[i].email
                }
                let response = null;
                if (profile.role_id === roles.ROLE_ADMIN) {
                    response = admin_orgs.postOrgNotificationList(org_id, body);
                }
                if (profile.role_id === roles.ROLE_ORGANISATION_ADMIN){
                    response = orgadmin_ords.postOrgNotificationList( body);
                }
                response.then(
                    response => {
                        let array = [...users]
                        array[i].email = "{sent}"
                        setUsers(array);
                        setShowSuccessDialog(true)
                    }
                ).catch(err => {
                    setError(err.response.data.title);
                    setErrorDescription(err.response.data.description)
                    setShowErrorDialog(true);
                })
            }
        }
    }

    const updateEmail = (ev) => {
        if (!ev.target) return;
        if (!users) return;
        const index = parseInt(ev.target.id);

        let array = [...users];
        array[index].email = ev.target.value;
        setUsers(array);
    }

    const handleBackClick = () => {
        hide();
    }

    const handleSuccessDialogResult = (res) => {
        setShowSuccessDialog(false);
    }

    useEffect(() => {
        let array = [];
        for(let i=0;i<4;i++){
            let user = {}
            user.email = "";
            array.push(user);
        }
        setUsers(array);
    }, [])

    return (
        <>
            <div className="admin-newuser-grid-container">
                <div className="admin-newuser-header link">
                    <img className="link" src={arrow} alt="arrow icon" onClick={handleBackClick}/>
                    Back
                </div>
                <div className="admin-newuser-grid-heading">
                    Notification Member
                </div>
                <div className="admin-newuser-grid-content">
                    {users && users.map((user, idx) => {
                        return (
                            <>
                                <input type="email" value={user.email} placeholder="Email address" id={idx}
                                       onChange={(ev) => updateEmail(ev)}/>
                            </>
                        )
                    })
                    }
                </div>
                <div className="admin-newuser-buttons">
                    <div className="admin-newuser-invite-button link" onClick={handleSendClick}>Send invites</div>
                    <div className="admin-newuser-cancel-button link" onClick={handleCancelClick}>Cancel</div>
                </div>
            </div>
                {showErrorDialog ?
                    <GenericDialog
                        title={error}
                        text={errorDescription}
                        buttons={okButton}
                        result={handleOKDialogResult}
                    /> : null }

                {showSuccessDialog ?
                    <GenericDialog
                        title={successTitle}
                        text={successDescription}
                        buttons={okButton}
                        result={handleSuccessDialogResult}
                    /> : null }

        </>
    )
}

export default OrganisationAddNotificationMembers